<template>
  <div>
    <div class="w-full">
      <select-table />
    </div>
  </div>
</template>

<script>
  import SelectTable from '@/components/bill/SelectTable'

  export default {
    components : {
      SelectTable
    }
  }
</script>

<style>

</style>